
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import React, { useEffect } from 'react';
import $ from 'jquery';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link,useNavigate } from "react-router-dom";
import PureCounter from "@srexi/purecounterjs";
const About = () => {
  useEffect(() => {
    // Initialize Slick Slider
    const $ = window.$;
    $("#slider1").slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 7000,
      cssEase: "linear",
      pauseOnHover: true,
    });

    // Initialize Swiper
    new Swiper(".review-swiper", {
      slidesPerView: 4,
      spaceBetween: 15,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        1024: { slidesPerView: 4 },
        768: { slidesPerView: 2 },
        480: { slidesPerView: 1 },
      },
    });

    // Initialize AOS
    AOS.init();

    // PureCounter
    new PureCounter({
      selector: ".purecounter",    
      start: 0,
      end: 500,
      duration: 1,
      delay: 10,
      once: true,
      pulse: false,
      decimals: 0,
      legacy: true,
      filesizing: false,
      currency: false,
      formater: "us-US",
      separator: false,
    });

    // // Add scroll event listener for navbar shadow
    // window.addEventListener("scroll", () => {
    //   const navbar = document.querySelector(".navbar");
    //   if (window.scrollY > 50) {
    //     navbar.classList.add("shadow");
    //   } else {
    //     navbar.classList.remove("shadow");
    //   }
    // });

    // return () => {
    //   window.removeEventListener("scroll", () => {});
    // };
  }, []);
  return (
    <div>
   <Navbar/>
   <div class="container  aboutUsContainer">
      <section class="history-area about-section">
        <div class="container position-lg-absolute z-index-11">
          <header>
            <h3 class="section-header">Our History</h3>
          </header>
          {/* <!-- end row --> */}
          <div class="container">
            <div class="col-lg-12">
              <div
                id="history-slid"
                class="carousel slide"
                data-bs-ride="carousel"
                data-bs-interval="false"
              >
                {/* <!-- Wrapper for slides --> */}
                <div class="carousel-inner">
                  <div class="carousel-item row d-flex">
                    <div class="col-lg-6 col-md-12 pl-0">
                      <div class="history-img">
                        <img
                          class="img-fluid"
                          src="https://i.ibb.co/CKNmhMX/blog1.jpg"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-12 pr-0">
                      <div class="history-content">
                        <p
                          class="title-bg-small primary-bg wow fadeInUp"
                          data-wow-duration="1.5s"
                          data-wow-delay="500ms"
                        >
                         Who we are
                        </p>
                        <h2
                          class="column-title wow fadeInUp"
                          data-wow-duration="1.5s"
                          data-wow-delay="700ms"
                        >
                         <span>CloudMinds</span>
                        </h2>
                        <p>
                        We are a team of tech innovators, problem-solvers, and digital transformation experts dedicated to delivering cutting-edge technology solutions. Our mission is to empower businesses with scalable, secure, and intelligent technology that enhances efficiency and growth.
                        </p>
                        <p>
                        With a strong foundation in innovation, reliability, and customer-centric solutions, we bridge the gap between technology and business success. Whether you're a startup or an enterprise, We are your trusted partner in building a smarter, more connected future.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <!-- End off item--> */}
                </div>
                {/* <!-- End off carusel inner -->
                <!-- Indicators --> */}
                <ol class="carousel-indicators text-center">
                  <li
                    data-bs-target="#history-slid"
                    data-bs-slide-to="5"
                    class="active"
                  >
                    2025
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="facts">
        <div class="container" data-aos="fade-up">
          <header>
            <h3 class="section-header">Facts</h3>
          </header>
          <div class="row counters">
            <div class="col-lg-3 col-6 text-center">
              <span
                data-purecounter-start="0"
                data-purecounter-end="3"
                data-purecounter-duration="1"
                class="purecounter"
              ></span>
              <p>Clients</p>
            </div>

            <div class="col-lg-3 col-6 text-center">
              <span
                data-purecounter-start="0"
                data-purecounter-end="5"
                data-purecounter-duration="1"
                class="purecounter"
              ></span>
              <p>Projects</p>
            </div>

            <div class="col-lg-3 col-6 text-center">
              <span
                data-purecounter-start="0"
                data-purecounter-end="24"
                data-purecounter-duration="1"
                class="purecounter"
              ></span>
              <p>Hours Of Support</p>
            </div>

            <div class="col-lg-3 col-6 text-center">
              <span
                data-purecounter-start="0"
                data-purecounter-end="10"
                data-purecounter-duration="1"
                class="purecounter"
              ></span>
              <p>Hard Workers</p>
            </div>
          </div>

          <div class="facts-img">
            <img src="assets/img/facts-img.png" alt="" class="img-fluid" />
          </div>
        </div>
      </section>
    </div>
  

   {/* <section className="about-content">
    <div className="about-container">
      <h2>Our Story</h2>
      <p>Founded in 2024, our mission is to empower businesses and individuals through cutting-edge technology and creative thinking. We believe in the power of collaboration and strive to deliver exceptional results for our clients.</p>
      <p>Our journey began with a small team of visionaries who shared a common goal: to make a difference in the world. Today, we are proud to have grown into a diverse and talented group of professionals who are committed to excellence.</p>
    </div>
  </section>
   

  
   <section className="about-content">
    <div className="about-container">
      <h2>"We Are Innovators in IT"</h2>
      <p className="author">Building the future of technology, one line of code at a time.</p>
    </div>
  </section>
   

   
   <section className="about-content">
    <div className="about-container">
      <h2>Ready to Work With Us?</h2>
      <p className="author">Let’s create something amazing together. Get in touch with us today!</p>

    </div>
 

   </section>
   
   
   <section className="about-content">
    <div className="about-container">
      <h2>Our Mission</h2>
      <p className="author">At <strong>CloudMinds</strong>, our mission is to innovate and provide cutting-edge IT solutions that drive digital transformation for businesses globally. 
      We aim to simplify complex technologies for the greater good, empowering companies to be more agile, efficient, and competitive in the digital landscape.</p>
    </div>
  

   </section>
   
   <section className="about-content">
    <div className="about-container">
      <h2>Our Vision</h2>
      <p className="author"> To empower businesses with technology that enhances their operations and growth. We envision a future where IT solutions are intuitive, scalable, and impactful.
                By fostering collaboration, driving innovation, and creating seamless integrations, we aim to become a trusted partner in the digital era.</p>
    </div>
  
   </section> */}

<Footer/>
    </div>
  )
}

export default About
